import axios from "axios";

export const getRequisitionsGridService = (query) => {
    return axios.get(`api/requisitions/manage?${`$count=true&`}${query}`);
};

export const getRequisitionsVendorGridService = (query) => {
    return axios.get(`api/requisitions/vendor/manage?${`$count=true&`}${query}`);
};

export const getRequisitionsVendorExcelService = (query: string, isRateLockdown: any, displayClientAtsReq: boolean, displaySalesforceContractNumber: boolean, displayEntityNumber:boolean) => {
    const additionalParams = `&isRateLockdown=${encodeURIComponent(isRateLockdown)}
                              &displayClientAtsReq=${encodeURIComponent(displayClientAtsReq)}
                              &displaySalesforceContractNumber=${encodeURIComponent(displaySalesforceContractNumber)}
                             &displayEntityNumber=${encodeURIComponent(displayEntityNumber)}`;
    const url = `api/requisitions/vendor/excel?${`$count=true&`}${query}${additionalParams}`;
    return axios.get(url);
};

export const getRequisitionsExcelService = (query: string, isRateLockdown: any, displayClientAtsReq: boolean, displaySalesforceContractNumber: boolean, displayEntityNumber:boolean) => {
    const additionalParams = `&isRateLockdown=${encodeURIComponent(isRateLockdown)}
                              &displayClientAtsReq=${encodeURIComponent(displayClientAtsReq)}
                              &displaySalesforceContractNumber=${encodeURIComponent(displaySalesforceContractNumber)}
                              &displayEntityNumber=${encodeURIComponent(displayEntityNumber)}`;
    const url = `api/requisitions/excel?${`$count=true&`}${query}${additionalParams}`;
    return axios.get(url);
};
